import { render } from "./VerifyInformation.vue?vue&type=template&id=67ca1b62"
import script from "./VerifyInformation.vue?vue&type=script&lang=js"
export * from "./VerifyInformation.vue?vue&type=script&lang=js"

import "./VerifyInformation.vue?vue&type=style&index=0&id=67ca1b62&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__